import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
} from "@material-ui/core";

import Activities from "./expanded-row/Activities";
import Deliverables from "./expanded-row/Deliverables";
import { Group } from "ra-friendsofbabba";
import React from "react";
import { useTranslate } from "react-admin";

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: 42,
    marginRight: 10,
    marginTop: 30,
    marginBottom: 10,
    "& th": {
      fontWeight: "bold",
    },
    "& td": {
      borderBottom: 0,
    },
  },
}));

const ExpandedRow = ({ record }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Group>
      <Table className={classes.root}>
        <TableHead>
          <TableRow>
            <TableCell>
              {translate(
                "resources.executive-project-wps.fields.expected_results"
              )}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{record.expected_results}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Activities
        record={record.executive_project_wp_activities}
        resource="executive-project-wp-activities"
        indexWp={record.index}
      />
      <Deliverables
        record={record.executive_project_wp_deliverables}
        resource="executive-project-wp-deliverables"
        indexWp={record.index}
      />
    </Group>
  );
};

export default ExpandedRow;
